// =====================================================
// 📁 POSIncotermSection.tsx
// =====================================================

import { useEffect } from 'react';

import { useSale } from '../../../../../hooks/sale/useSale';

import { useIncoterm } from '../../../../../hooks/incoterm/useIncoterm';

import { useExportInvoiceSale } from '../../../../../hooks/sale/useExportInvoiceSale';

import POSSelectField from '../../../../POS/Fields/POSSelectField';

const POSIncotermSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form } = useSale();

  const { handlerUpdateIncoterm } = useExportInvoiceSale();

  const {
    incotermDropdown,

    fetchIncoterms,
  } = useIncoterm();

  // =====================================================
  // 🔹 Effects
  // =====================================================
  useEffect(() => {
    fetchIncoterms();
  }, []);

  // =====================================================
  // 🔹 Options
  // =====================================================
  const options = incotermDropdown.map((item) => ({
    value: item.id,

    label: item.name,
  }));

  // =====================================================
  // 🔹 Selected
  // =====================================================
  const selectedValue = form.exportInvoiceExtra?.incoterm?.id ?? '';

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div className="space-y-2">
      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <div>
        <h4
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          INCOTERMS
        </h4>

        <p
          className="
            mt-1

            text-xs
            text-body
          "
        >
          Selecciona el INCOTERM correspondiente para la operación de
          exportación.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Select */}
      {/* ===================================================== */}
      <POSSelectField
        label="INCOTERM"
        name="incoterm"
        placeholder="Seleccione INCOTERM"
        value={selectedValue}
        options={options}
        iconKey="list"
        onChange={async (e) => {
          const selectedId = Number(e.target.value);

          if (!form?.id) {
            return;
          }

          await handlerUpdateIncoterm(form.id, selectedId);
        }}
      />
    </div>
  );
};

export default POSIncotermSection;
